import loadable from "@loadable/component";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import PickupRequesticon from "../Icons/PickupRequesticon";
import useGetHook from "../customHooks/useGetHook";
import APIS from "../constant/EndPoint";
import Spinner from "../Components/Reusable/Spinner";
const PickupRequestListComponent = loadable(
  () => import("../Components/PickupRequest/PickupRequestList")
);
const PickupRequestList = () => {
  const { data: draftOrder, isLoading: isDataLoading } = useGetHook({
    queryKey: [`draft-order`],
    url: `${APIS.DRAFT_ORDER}`,
    params: {},
  });
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <PickupRequesticon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Pickup Request
        </span>
      </div>
      {isDataLoading ? <Spinner /> : <PickupRequestListComponent draftOrder={draftOrder} />}
    </>
  );
};

export default PickupRequestList;
